import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import RaikoSimpleInputOutlined from "../../raikoComponents/raikoCustomInput/RaikoSimpleInputOutlined";
import {useState} from "react";
import {css} from "@emotion/css";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import ButtonDivisionSection from "../ButtonDivisionSection/ButtonDivisionSection";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {NEWS_TYPES, NewsService} from "../../serverService/newsService/NewsService";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import RaikoCustomSelect, {
    raikoCustomSelectItemGenerator
} from "../../raikoComponents/raikoCustomSelect/RaikoCustomSelect";
import RaikoGridTwoColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridTwoColumn";

export default function AddNews({handleAddToRow, handleCloseDialog}) {
    const [title, setTitle] = useState("");
    const [newsType, setNewsType] = useState(NEWS_TYPES.NEWS.id);

    const loading = new LoadingHelper(useLoadingDispatcher())
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())
    const service = new NewsService()

    function handleCreateNewNews() {
        if (title && title.length > 0) {
            loading.show()
            service.addNewNews(title, newsType)
                .then(response => {
                    handleAddToRow(response)
                    snackbar.showSuccessMessage("خبر جدید با موفقیت افزودن شده")
                    clearFields()
                    handleCloseDialog()
                    loading.hide()
                }).catch(reason => {

                snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در افزودن خبر جدید!"))
                loading.hide()
            })
        }
    }

    function clearFields() {
        setTitle("")
        setNewsType(NEWS_TYPES.NEWS.id)
    }

    return (<RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem`}>
        <RaikoGridOneColumn>
            <RaikoSimpleInputOutlined
                labelText={"عنوان خبر"}
                setValue={setTitle}
                value={title}
            />
            <RaikoCustomSelect
                labelText={"نوع خبر"}
                setValue={setNewsType}
                items={[
                    raikoCustomSelectItemGenerator(NEWS_TYPES.NEWS.id, NEWS_TYPES.NEWS.title),
                    raikoCustomSelectItemGenerator(NEWS_TYPES.EXECUTIVE_COMMITTEE.id, NEWS_TYPES.EXECUTIVE_COMMITTEE.title),
                    raikoCustomSelectItemGenerator(NEWS_TYPES.CRAFT_UNION.id, NEWS_TYPES.CRAFT_UNION.title),
                ]}
                value={newsType}
            />
        </RaikoGridOneColumn>
        <ButtonDivisionSection>
            <ButtonPrimaryRaiko
                onClick={handleCreateNewNews}
                label={"ثبت و افزودن"}/>
        </ButtonDivisionSection>
    </RaikoGridOneColumn>)
}